import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {HarlequinGameAssets} from "../../HarlequinGameAssets";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineLite, TweenLite} from "gsap";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {SlideShow, SlideShowColors} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShow";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {HarlequinBackground} from "../../background/HarlequinBackground";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {Harlequin} from "../../Harlequin";

/**
 * Created by jonas on 2020-03-23.
 */

export class HarlequinSlideShowFSIntroView extends PIXI.Container implements StageLayer {
    private borderTop:PIXI.Container;
    private borderBottom:PIXI.Container;
    private _slideShow:SlideShow;
    private colors:SlideShowColors = {
        backgroundColor:0x000000,
        backgroundAlpha:0.6,
        bulletColor:0xffffff
    };
    private _continueButton:ContinueButton;
    private _completeCallback?:() => void;
    private _darkenPlate:PIXI.Sprite;
    private _freespinsLeft:number;
    private _restore:boolean;


    constructor() {
        super();

        this._darkenPlate = new PIXI.Sprite(GameResources.getTextures(HarlequinGameAssets.BACK_GROUND_DARKENING)[0]);
        this._darkenPlate.tint = 0x1300E3;// AE;
        this._darkenPlate.alpha = 0.65;
        this._darkenPlate.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this._darkenPlate.scale.set(10, 10);
        this._darkenPlate.anchor.set(0.5, 0.5);
        this._darkenPlate.position.set(360, 360);


        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_BORDER_TILE), 1680, 77);
        topSprite.anchor.set(0.5, 0.2);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(HarlequinGameAssets.INTRO_BORDER_TILE), 1680, 77);
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.2);
        this.borderBottom.addChild(bottomSprite);


        const featureText1 = SlotGame.api.translations.translate(!Harlequin.api.gameClientConfiguration.showLowProbabilityGfx ? "Harlequin xNudge Wilds may be multiplied till x7!" : "Harlequin xNudge Wilds may be multiplied up to x7!");
        const featureText3 = SlotGame.api.translations.translate("Collect 3 Wilds to get a guaranteed Harlequin xNudge Wild on reel 5. Each Wild awards +1 spin.");

        const pages = [
            new SlideShowPage(ImgLoader.getImgTexture(!Harlequin.api.gameClientConfiguration.showLowProbabilityGfx?HarlequinGameAssets.INTRO_FEATURE_3_US:HarlequinGameAssets.INTRO_FEATURE_3), featureText3),
            new SlideShowPage(ImgLoader.getImgTexture(!Harlequin.api.gameClientConfiguration.showLowProbabilityGfx?HarlequinGameAssets.INTRO_FEATURE_1_US:HarlequinGameAssets.INTRO_FEATURE_1), featureText1)
        ];
        this._slideShow = new SlideShow(pages, this.borderTop, this.borderBottom, this.colors);
        this._continueButton = new ContinueButton();
        this._continueButton.addClickCallback(this.continueButtonClicked);
        this._continueButton.enable(false);
        this._continueButton.pivot.set(this._continueButton.width * 0.5, this._continueButton.height * 0.5);

        this.addChild(this._darkenPlate, this._slideShow, this._continueButton);
    }

    private continueButtonClicked = () => {
        if (this._completeCallback) {
            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.CONTINUE);
            this._completeCallback();
        }
    };

    onResize():void {
        const bounds = NolimitApplication.screenBounds;
        this._slideShow.changeWidth(bounds.width);
    }

    onOrientationChanged():void {
        this._slideShow.position.set(360, 130);
        if (NolimitApplication.isLandscape) {
            this._continueButton.position.set(360, 630);
        } else {
            const centerBottom = (NolimitApplication.screenBounds.bottom - 580) * 0.5 + 580;
            this._continueButton.position.set(360, centerBottom);
        }

    }

    prepare(data:ParsedServerData):void {
        this._freespinsLeft = data.freespinsLeft;
        this._restore = (<any> data).isRetoreState;
    }

    getStartAnimation(prepareToEnterModeCallback:() => void, completeCallback:() => void):TimelineLite {
        this._completeCallback = completeCallback;
        const tl:TimelineLite = new TimelineLite({
            onStart:() => {
                //SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft);
                this.alpha = 0;
                NolimitApplication.addLayer("FreespinIntro", this);
                if(this._restore) {
                    HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("NewThirdScatterDefault");
                }
                HarlequinGameModuleConfig.harlequinSignView.playLeftBar("NewBaseGameDefault", 0, false);
                this.onOrientationChanged();
                this.onResize();
            }

        });

        tl.add([
            new TweenLite(this, 0.2, {alpha:1}),
            () => {
                this._slideShow.start();
                this._slideShow.navToIndex(1);
                this._continueButton.enable(true);
                SlotGame.sound.playEffect(HarlequinSoundConfig.instance.FREESPIN_INTRO);
                (<HarlequinBackground>HarlequinGameModuleConfig.background).playBgSpine("bonusGame");
                SlotGame.sound.fadeAmbience(0, 50);
                SlotGame.sound.playAmbience(HarlequinSoundConfig.instance.FREESPIN_AMBIANCE);
                SlotGame.sound.fadeAmbience(1, 50);
                //SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft);
            }
        ], "+=0.5");
        tl.add(() => prepareToEnterModeCallback());

        return tl;
    }

    getEndAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite({
            onStart:() => {
                this._continueButton.enable(false);
            },
            onComplete:() => {
                this._slideShow.stop();
                NolimitApplication.removeLayer("FreeSpinIntro");
                this._completeCallback = undefined;
                SlotGame.keypad.setZeroBetSpinCounter(this._freespinsLeft);

                // This will turn off Autoplay if in restricted jurisdiction
                if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
                    SlotGame.autoPlay.turnOffAutoplayOnBonus();
                }
            }
        });

        tl.add(new TweenLite(this, 0.2, {alpha:0}));

        return tl;
    }
}